import GET_LINK_BLOCK from '../plugins/get-link-block'
import GET_BANNER_BLOCK from '../plugins/get-banner-block'

const [ w, d, mq ] = [ window, document, window.matchMedia( "(max-width: 900px)" ) ]

const init = () => {

  if( w.load['loadHtml'] ){
    w.load['loadHtml'].then( () => {
      // ナビゲーションカレント
      $('.nav-aboutus[data-plugin="currentMenu"]').currentMenu({mode:0})
    })
  }

  // リンクブロック、バナーブロック 呼び出し
  $.when( w.load['aboutus-01'] ).then( () => {
    GET_LINK_BLOCK()
    GET_BANNER_BLOCK()
  })
  $.when( w.load['aboutus-02'] ).then( () => {
    GET_LINK_BLOCK()
    GET_BANNER_BLOCK()

    // よくある質問アンカーリンクのgNav閉じ
    const flowPage = d.querySelector('.is--article-2');
    if(flowPage){
      const hashLink = document.querySelectorAll('.p-gnav__subnav-list a[href*="#"]');
      
      hashLink.forEach(link => {
        link.addEventListener('click', () => {
          const openBtn = document.querySelector('.drawerNav-btn.is-active');
          const gNav = document.querySelector('.p-gnav.is-open');
          const filter = document.querySelector('.is-drawer-active');
          
          openBtn.classList.remove('is-active');
          gNav.classList.remove('is-open');
          filter.classList.remove('is-drawer-active');
        });
      });
    }
  })

}

export default function ABOUTUS() {
  $( init )
}